module.exports = __webpack_public_path__ + "img/20180815_150347_067.d57a9d81.jpg";